module.exports = __webpack_public_path__ + "static/media/b3.5e795b7d.png";